class SwatchBuilderMoreInfo extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.onDrawerTrigger = this.onDrawerTrigger.bind(this)
    this.handleRevealSwatchBuilderBar =
      this.handleRevealSwatchBuilderBar.bind(this)
  }

  isLoading = false

  get loading () {
    return this.isLoading
  }

  set loading (val) {
    this.isLoading = val
    this.classList.toggle('drw-SwatchBuilderMoreInfo-loading', val)
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener('click', this.onDrawerTrigger, { capture: true })

    document.addEventListener('click', this.handleRevealSwatchBuilderBar)

    this.addToCart = this.addToCart.bind(this)
    document.addEventListener('click', this.addToCart)
  }

  onDrawerTrigger (event) {
    const internalSelector =
      this.els.swatchBuilderMoreInfoTrigger?.selector || null
    const externalSelector =
      this.externalEls.swatchBuilderMoreInfoTrigger?.selector || null

    const triggerInternal = internalSelector
      ? event.target.closest(internalSelector)
      : null

    const triggerExternal = externalSelector
      ? event.target.closest(externalSelector)
      : null

    if (triggerExternal) {
      const productHandle = triggerExternal.dataset.productHandle

      if (productHandle) {
        this.loadProductData(productHandle)
      }
    } else if (triggerInternal) {
      const drawerElement = this.querySelector('site-drawer-custom')
      const isDrawerOpen =
        drawerElement?.classList.contains('drw-Drawer-active')

      if (isDrawerOpen) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }

      const productHandle = triggerInternal.dataset.productHandle

      if (productHandle) {
        this.loadProductData(productHandle)
      }
    }
  }

  async loadProductData (productHandle) {
    try {
      this.showLoadingState()

      const sectionHtml = await window.BAO.sectionRenderer.fetchSingle(
        'swatch-builder-more-info',
        `/products/${productHandle}`,
      )

      this.updateDrawerContent(sectionHtml)
      this.hideLoadingState()
    } catch (error) {
      console.error('Error loading swatch info:', error)
      this.hideLoadingState()
    }
  }

  updateDrawerContent (html) {
    const headerTitleContent = this.externalEls.headerTitleContent.element
    const drawerMainContent = this.els.drawerMainContent.element
    const footerButtonContent = this.els.footerButtonContent.element

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    if (headerTitleContent) {
      const sectionContent = doc.querySelector(
        '[data-swatch-builder-more-info-external-el="headerTitleContent"]',
      )
      if (sectionContent) {
        headerTitleContent.innerHTML = sectionContent.innerHTML
      } else {
        headerTitleContent.innerHTML = html
      }
    }

    if (drawerMainContent) {
      const sectionContent = doc.querySelector(
        '[data-swatch-builder-more-info-external-el="drawerMainContent"]',
      )
      if (sectionContent) {
        drawerMainContent.innerHTML = sectionContent.innerHTML
      } else {
        drawerMainContent.innerHTML = html
      }
    }

    if (footerButtonContent) {
      const sectionContent = doc.querySelector(
        '[data-swatch-builder-more-info-external-el="footerButtonContent"]',
      )
      if (sectionContent) {
        footerButtonContent.innerHTML = sectionContent.innerHTML
      } else {
        footerButtonContent.innerHTML = html
      }
    }
  }

  showLoadingState () {
    this.loading = true
  }

  hideLoadingState () {
    this.loading = false
  }

  handleRevealSwatchBuilderBar (event) {
    if (!this.externalEls?.revealSwatchBuilderBarTrigger?.selector) {
      return
    }

    const addToSwatchBuilderButton = event.target.closest(
      this.externalEls.revealSwatchBuilderBarTrigger.selector,
    )

    if (addToSwatchBuilderButton) {
      const productHandle =
        addToSwatchBuilderButton.dataset.swatchBuilderActiveProductHandle

      if (productHandle) {
        window.BAO.dispatchEvent(
          window.BAO.EVENTS.SWATCH_BUILDER.PRODUCT_SELECTED,
          { productHandle },
        )
      }

      this.revealSwatchBuilderBar()
    }
  }

  revealSwatchBuilderBar () {
    const swatchBuilderBar = this.externalEls.swatchBuilderBar.element

    if (swatchBuilderBar) {
      swatchBuilderBar.setAttribute('aria-hidden', false)
    }
  }

  async addToCart (event) {
    const addToCartButton = event.target.closest(this.els.addToCart?.selector)

    if (!addToCartButton) {
      return
    }

    const variantId = addToCartButton.dataset.productId
    const isAvailable = addToCartButton.dataset.productAvailable === 'true'

    if (!variantId) {
      console.error('No variant ID found on add to cart button')
      return
    }

    if (!isAvailable) {
      return
    }

    try {
      addToCartButton.style.opacity = '0.7'
      addToCartButton.style.pointerEvents = 'none'
      addToCartButton.disabled = true

      await window.BAO.Cart.addItem(
        {
          id: variantId,
          quantity: 1,
        },
        {
          sections: window.BAO.sectionRenderer.pushCartSections.map(
            (s) => s.section,
          ),
        },
      )
    } catch (error) {
      console.error('Error adding to cart:', error)
    } finally {
      addToCartButton.style.opacity = '1'
      addToCartButton.style.pointerEvents = 'auto'
      addToCartButton.disabled = false
    }
  }
}

if (!customElements.get('swatch-builder-more-info')) {
  customElements.define('swatch-builder-more-info', SwatchBuilderMoreInfo)
}
